import React, { useEffect, useState } from "react";

import ContactPage from "./ContactPage";

import { RequestState } from "../../utils/RequestState";
import { sendEventTracking } from "../../utils/GeneralUtils";

import { postContact } from "../../services/api/user/postContact";
import { useMetaData } from "../../utils/useMetaData";

const ContactPageContainer: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const [error, setError] = useState<boolean>(false);

  const handleSubmit = async () => {
    if (!name || !email || !category || !message) {
      setError(true);
    }

    if (name && email && category && message) {
      setRequestState(RequestState.Doing);
      const res = await postContact(name, email, category, message);

      if (res) {
        sendEventTracking("click", "submit_contact_form", email);

        setRequestState(RequestState.Success);
        setName("");
        setEmail("");
        setCategory("");
        setMessage("");
      } else {
        setRequestState(RequestState.Failed);
      }
    }
  };

  useEffect(() => {
    if (name && email && category && message) {
      setError(false);
    }
  }, [name, email, category, message]);

  useMetaData({
    title: "お問い合わせ",
    description:
      "eスポーツを使ったPRやイベントキャスティングサービス「SELeCT」へのお問い合わせはこちら。eスポーツの「キャスティング」「イベント開催」「協賛」「スポンサー募集」などあらゆるお悩み・ご相談をお受けしております。企業、個人問わずぜひお気軽にお問い合わせください。",
    imgUrl: "",
  });

  return (
    <ContactPage
      requestState={requestState}
      error={error}
      setName={setName}
      setEmail={setEmail}
      setCategory={setCategory}
      setMessage={setMessage}
      handleSubmit={handleSubmit}
    />
  );
};

export default ContactPageContainer;
